import { MONTHS_SHORT_NAMES } from "../../../../../constants/dates";
import { formatNumber } from "../../dashboard-utils";
import {
  IGetInsurancePremiumPortfolioData,
  LstDato,
} from "../../../../../services/ClientsDashboardServices.dto";
import { Cell, ChartData, ChartItem, Row } from "../../clients-dashboard-types";

const getShortMonthName = (date: string): string => {
  const month = new Date(date).getMonth() + 1;
  const monthNumber = month < 10 ? `0${month}` : month;
  return MONTHS_SHORT_NAMES[monthNumber];
};

const sortByFechaInicio = (lstDatos: LstDato[]) => {
  return lstDatos.sort(
    (a, b) => new Date(a.fechaInicio).getTime() - new Date(b.fechaInicio).getTime()
  );
};

export const getTableData = (data: IGetInsurancePremiumPortfolioData) => {
  const headerCells: Cell[] = [
    { className: "", value: "Productos" },
    { className: "header", value: "Primas Altas" },
    { className: "header", value: "Primas Bajas" },
    { className: "header", value: "Cartera Periodo" },
  ];
  const headRow: Row = { className: "", cells: headerCells };
  const bodyRows: Row[] = [];
  const years: number[] = [];

  const sortedData = sortByFechaInicio(data.lstDatos);
  sortedData.forEach(({ fechaInicio, lstProducto }) => {
    const monthRows: Row[] = [];
    const year = new Date(fechaInicio).getFullYear();
    const shortMonthName = getShortMonthName(fechaInicio);

    if (!years.includes(year)) {
      const yearRow: Row = {
        className: "year",
        cells: [
          { className: "", value: year, contractActionList: [`${year}`] },
          { className: "", value: "" },
          { className: "", value: "" },
          { className: "", value: "" },
        ],
      };
      bodyRows.push(yearRow);
      years.push(year);
    }

    const sortedLstProducto = lstProducto.sort((a, b) => a.nombre.localeCompare(b.nombre));
    sortedLstProducto.forEach(({ nombre, primasAltas, primasBajas, primasCarteraPeriodo }) => {
      if (nombre === "Total") {
        const monthRow: Row = {
          className: "month strong",
          cells: [
            {
              className: "strong",
              value: shortMonthName,
              contractActionList: [`${year}${shortMonthName}`],
            },
            { className: "number strong", value: formatNumber(primasAltas) },
            { className: "number strong", value: formatNumber(primasBajas) },
            { className: "number strong", value: formatNumber(primasCarteraPeriodo) },
          ],
          contractByList: [`${year}`],
        };
        monthRows.unshift(monthRow);
      } else {
        const productRow: Row = {
          className: "product",
          cells: [
            { className: "", value: nombre },
            { className: "number", value: formatNumber(primasAltas) },
            { className: "number", value: formatNumber(primasBajas) },
            { className: "number", value: formatNumber(primasCarteraPeriodo) },
          ],
          contractByList: [`${year}`, `${year}${shortMonthName}`],
        };
        monthRows.push(productRow);
      }
    });
    bodyRows.push(...monthRows);
  });

  return {
    headRow,
    bodyRows,
  };
};

export const getInsurancePremiumPortfolioChartData = (
  data: IGetInsurancePremiumPortfolioData
): ChartData => {
  const newData: ChartData = [];
  const firstMonthProducts = data.lstDatos[0].lstProducto.map(({ nombre }) => nombre);

  const sortedData = sortByFechaInicio(data.lstDatos);
  sortedData.forEach(({ fechaInicio, lstProducto }, index) => {
    const year = new Date(fechaInicio).getFullYear();
    const newMonthData: ChartItem = {
      month: getShortMonthName(fechaInicio),
      year,
    };
    lstProducto.forEach(({ nombre, primasCarteraPeriodo }) => {
      if (nombre !== "Total") {
        newMonthData[nombre] = primasCarteraPeriodo;

        // El primer objeto del chart necesita el nombre de todos los productos
        if (index > 0 && !firstMonthProducts.includes(nombre)) {
          newData[0][nombre] = 0;
          firstMonthProducts.push(nombre);
        }
      }
    });
    newData.push(newMonthData);
  });
  return newData;
};
